import { ButtonRoundSm } from '@apps-common/components/elements'
import { ModalButton } from '@apps-common/components/modals/ModalButton'
import { QrCodePortalUnitModal } from '@apps-common/components/qr-code/qr-code-portal-unit/QrCodePortalUnitModal'
import { commonIcons } from '@apps-common/config/icons'
import { modalFadeInEnterAnimation, modalFadeInLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  disabled?: boolean
  unitId?: string
}

export const QRCodePortalUnitButton: React.FC<IProps> = ({ disabled, unitId }) => (
  <ModalButton
    component={QrCodePortalUnitModal}
    disabled={disabled}
    componentProps={{ unitId }}
    enterAnimation={modalFadeInEnterAnimation}
    leaveAnimation={modalFadeInLeaveAnimation}
    backdropDismiss
  >
    <ButtonRoundSm
      type='div'
      className='action-brand'
      disabled={disabled}
      tooltip={{ id: `portal-unit-qr-code-${unitId}`, message: 'Generate QR Code' }}
    >
      <commonIcons.qrCode />
    </ButtonRoundSm>
  </ModalButton>
)
